type UserAuthTokenPersister = (token: string | undefined) => void | Promise<void>

let persister: UserAuthTokenPersister | undefined

export function registerUserAuthTokenPersister(next: UserAuthTokenPersister) {
  persister = next
}

export async function persistUserAuthTokenFromResponse(token: string | undefined) {
  await persister?.(token)
}
